import { useQuery } from 'react-query';

import {
  GetSubsetFactsResponse,
  PageCursors,
} from '../../../../backend/src/matter/subset/dto/response-get-subset.facts.dto';
import { FactFilters } from '../../types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { createFilterBody } from '@/helpers/createFilterParams';

interface GetSubsetFactsProps {
  matterId: string;
  subsetId: string;
  searchQuery?: string;
  page?: number;
  knownCursors?: PageCursors[];
  filters: FactFilters;
  refetchInterval?: number | false;
}

function useGetSubsetFacts({
  matterId,
  subsetId,
  searchQuery,
  filters,
  page,
  knownCursors,
  refetchInterval,
}: GetSubsetFactsProps) {
  const { getFetchConfig } = useGetFetchConfig();
  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data: {
      searchQuery: searchQuery || '',
      paginated: true,
      ...(page !== undefined ? { page } : {}),
      ...(knownCursors !== undefined && knownCursors.length > 0 ? { knownCursors } : {}),
      ...createFilterBody(filters),
    },
  });

  // The query key is keyed only on `page` (not on knownCursors).
  return useQuery<GetSubsetFactsResponse, Error>(
    [QueryEntity.SubsetFacts, { subsetId, searchQuery, filters, page }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/facts`, {
        ...fetchConfigPOST,
      });
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    {
      refetchOnWindowFocus: false,
      refetchInterval: refetchInterval ?? false,
    },
  );
}

export default useGetSubsetFacts;
